angular.module('impactx.list').directive('ixListPopupFilter', function(){
    return {
        restrict: 'E',
        scope: {
            field: '=',
            suffix: '=',
            columnName: '='
        },
        require: '^stTable',
        templateUrl: 'shared/list/templates/listpopupfilter.tmpl.html',
        link: function (scope, element, attr, ctrl) {
            function getSelectedOptions() {
                var selectedOptions = [];

                angular.forEach(scope.field.entries, function(item) {
                    if (item.value && item.selected) {
                        var newObj = {};
                        newObj[scope.columnName] = item.value;
                        selectedOptions.push(newObj);
                    }
                });

                return selectedOptions;
            }
            scope.change = function change () {
                ctrl.search(getSelectedOptions(), scope.columnName)
            };
            scope.change();
        }
    }
});
